import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { LodgingHeadingViewModel } from 'models';

import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

import { ResultProps } from 'components/search/result';

export interface ListTitleProps extends ResultProps {
  model: LodgingHeadingViewModel;
}

export const ListTitle: React.FC<ListTitleProps> = React.memo(({ model: { value, size, tag }, className }) => (
  <ErrorBoundary label="hotel.search.listingTitle">
    <li className={`uitk-cell ${className}`}>
      <UitkSpacing padding={{ blockstart: 'three' }}>
        <UitkHeading tag={tag} size={size}>
          {value}
        </UitkHeading>
      </UitkSpacing>
    </li>
  </ErrorBoundary>
));

ListTitle.displayName = 'ListTitle';
